/* eslint-disable pixelated/enforce-single-h1 */

"use client";

import React, { useState, useEffect } from "react";

import { ResumeName, ResumeContact, ResumeQualifications, ResumeSkills, 
	ResumeSummary, ResumeEvents, ResumeProjects, ResumeReferences, 
	PageSection,
	PageGridItem,
	SmartImage} from "@pixelated-tech/components";
import { Modal, handleModalOpen } from "@pixelated-tech/components";
import ResumeData from "@/app/data/resume.json";

export default function ResumePage() {
	const [modalContent, setModalContent] = useState<React.JSX.Element | undefined>();

	useEffect(() => {
		const handleImageClick = (event: Event) => {
			event.preventDefault();
			const url = (event.target as HTMLElement).parentElement?.getAttribute('href') || '';
			const myContent: React.JSX.Element = <SmartImage src={url} alt="Modal Image" />;
			setModalContent(myContent);
			handleModalOpen(event as MouseEvent);
		};

		const images = document.querySelectorAll('.u-photo-icon');
		images.forEach(image => image.addEventListener('click', handleImageClick));

		return () => {
			images.forEach(image => image.removeEventListener('click', handleImageClick));
		};
	}, []);
	return (
		<>
			<PageSection columns={12} className="p-resume" id="resume-section">
				<PageGridItem columnStart={1} columnEnd={13} className="p-name">
					<ResumeName data={ResumeData.items[0].properties.name} />
				</PageGridItem>
				<PageGridItem columnStart={1} columnEnd={4} className="divider">
					<div className="p-contact">
						<ResumeContact title="Contact Information" data={ResumeData.items[0].properties.contact} />
					</div>
					<div className="p-education">
						<ResumeEvents title="Education" data={ResumeData.items[0].properties.education} dateFormat="MM/yyyy" collapsible={false} />
					</div>
					<div className="p-skills">
						<ResumeSkills title="Skills" data={ResumeData.items[0].properties.skills} />
					</div>
				</PageGridItem>
				<PageGridItem columnStart={4} columnEnd={13}>
					<div className="p-summary">
						<ResumeSummary title="Professional Summary" data={ResumeData.items[0].properties.summary} />
					</div>
					<div className="p-qualifications">
						<ResumeQualifications title="Professional Qualifications" data={ResumeData.items[0].properties.qualifications} />
					</div>
					<div className="p-experience">
						<ResumeEvents title="Work History" data={ResumeData.items[0].properties.experience} dateFormat="MM/yyyy" collapsible={false} />
					</div>
					<div className="p-projects">
						<ResumeProjects title="Projects" data={ResumeData.items[0].properties.experience} collapsible={true} />
					</div>
					<div className="p-volunteer">
						<ResumeEvents title="Volunteer Work" data={ResumeData.items[0].properties.volunteer} dateFormat="MM/yyyy" collapsible={true} />
					</div>
					<div className="p-certifications">
						<ResumeEvents title="Certifications" data={ResumeData.items[0].properties.certifications} dateFormat="MM/yyyy" collapsible={true} />
					</div>
					<div className="p-awards">
						<ResumeEvents title="Honors & Awards" data={ResumeData.items[0].properties.awards} dateFormat="MM/yyyy" collapsible={true} />
					</div>
					<div className="p-training">
						<ResumeEvents title="Training & Conferences" data={ResumeData.items[0].properties.training} dateFormat="MM/dd/yyyy" collapsible={true} />
					</div>
					<div className="p-references">
						<ResumeReferences title="References" data={ResumeData.items[0].properties.references} collapsible={true} />
					</div>
				</PageGridItem>
			</PageSection>

			<Modal modalContent={modalContent ?? <></>} />
		</>
  	);
}
